<template>
  <li class="news-item">
    <strong>{{ newsData.title }}</strong>
    <div class="notification-timestamp">
      <div class="sr-only" aria-label="Dato for nyhed"></div>{{ timeStamp }}
    </div>
    <br>
    <span v-html="fixedNewsData"></span>
  </li>
</template>

<script>
export default {
  data() {
    return {
      timeStamp: '',
      fixedNewsData: '',
    }
  },
  props: {
    newsData: {
      type: Object,
      required: true
    },
  },
  created() {
    //console.log(this.$props.newsData);
    this.fixedNewsData = this.newsData.message.replace(/(http:\/\/#|https:\/\/#)/g, '/');
    //console.log(this.fixedNewsData);
    let date = new Date(this.$props.newsData.start*1000);
    this.timeStamp = date.getDate()+'.'+(date.getMonth()+1)+'.'+date.getFullYear().toString().substr(2,3);
  },
}
</script>

<style lang="scss" scoped>
  .news-item {
    width: 100%;
    height: auto;
    margin-top: 10px;
    padding: 10px;
    background-color: #fdfdfd;
    box-shadow: 0 1px 2px rgba(0,0,0,.1);
  }

  .news-item:first-child {
    margin-top: 0px;
  }

  .news-item p {
    margin: 0;
  }

  .news-item ::v-deep a {
    text-decoration: underline;
  }

  .notification-timestamp {
    float: right;
    font-style: italic;
  }
</style>
